import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';

const useStyles = makeStyles((theme)=>({
    root: {
        padding: theme.spacing(10, 10,0,10),
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(7, 8,0,8),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 2,0,2),
        },
    },
    
}));


// const Content = styled('div')(({ theme }) => ({
//     padding: theme.spacing(7, 20,0,26),
// }));


export default function CustomContent(props) {
    const { children } = props;
    const classes = useStyles();
    return (
        <Grid item container xs ={12} className={classes.root}>
            {children}
        </Grid>
    );
}